var bInteractive=false;
var viewportWidth = window.innerWidth;


//console.log ("viewportWidth: " + viewportWidth);
// **************  START CONTEXT SEARCH ********************************************************

$(function () {
    var cache = {};

	$(window).on('resize', function() {
		 viewportWidth = $(window).width();
		//console.log("Viewport Width: " + viewportWidth);		
	});

    $("#btnSearchHotel,#btnSearchGuide,#btnSearchCruise,#btnGSearch,#btnSearchGuide2").on('click',function (e){ 
        e.preventDefault();  
		cts(this); 
		return false 
	});

    $("#txtHotelSearchTerm,#txtGuideSearchTerm,#txtGuideSearchTerm2,#txtGlobalSearchTerm,#txtShipSearchTerm").each(function (i) {
        $(this)
            .keydown(function(event) { if (event.keyCode == '13') {cts(this); return false } })
	        .autocomplete({
	            source: function(request, response) {
					var ctscntxt =$("#" + this.element[0].id).data("ac-context");
	                var Req = new Object();
	                Req.Term = request.term;
	                Req.Context = ctscntxt;	  
				    var DTO = { 'Request': Req };
	                var json = JSON.stringify(DTO);
	                $.ajax({
	                    url: "/AutoComplete.asmx/GetCompleteList",
	                    dataType: "json", type: "POST", contentType: "application/json; charset=utf-8", data: json,
	                    error: function() { response("") },
	                    success: function(data) {
	                        if (data.d) { data = data.d }
	                        var resp = $.map(data, function (item) {return { label: item.Name, value: item.Data, url: item.URL, placekey: item.Key, type: item.Type, src: ctscntxt }})
	                        response(resp)
	                    }
	                })
	            },
	            minLength: 3,
	            select: function(event, ui) {
					 var url=ui.item.url;  
	                if (url != null) { 
	                   if ( url.indexOf("xyz=1")>-1){cts(this); return false;}	
						
	                    if ($(this).data("rid")!="" && $(this).data("rid")!=undefined ){
							url=appndURL(url,"rid=" + $(this).data("rid"));
						}	
						winloc(url);
	                } else {return false;}
	            },
	            delay: 150,
	            open: function() { $(this).removeClass("ui-corner-all").addClass("ui-corner-top"); },
	            close: function() { $(this).removeClass("ui-corner-top").addClass("ui-corner-all"); }
	        }).data("ui-autocomplete")._renderItem = function (ul, item) {
                if (item.url == null) {
                    var s = "<img style='vertical-align:middle' vspace=0 hspace=0 src='/dist/images/ac/" +item.type + ".png?20240214'/>" +item.label
                    return $("<li class='ac-group'>").append(s).appendTo(ul);
                } else {
				return $("<li class='ac-item'>").append("<a>" +item.label + "</a>").appendTo(ul);
				}
			}
        });
        })

	   

	    function cts_event(event) {
			var ele=$("#" + event.currentTarget.id);
	
	        return cts(ele);
	    }
		    function cts(ele) {
			var context =  $(ele).data("ac-context");//get context from text field if that was the event
			if (context==undefined) {
				//otherwise it was the "button", set element to be the test field and continue
				ele=$(ele).parent().find("input");
				context =  $(ele).data("ac-context");
			}
		   var txtVal = $(ele).val(); 			
	        if (txtVal != '') {
	            var u = "";
	            u = "/Search?pst=" + encodeURIComponent(txtVal) + '&typ=' + context
				if ($(ele).data("rid")!="" && $(ele).data("rid")!=undefined ){
					u=appndURL(u,"rid=" + $(ele).data("rid"));	 
				}	
	            winloc(u)
	        }

	        return false;
	    }




// **************  END CONTEXT SEARCH ********************************************************  
